import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getRegions = () =>
  fetch(
    `${API_BASE_URL}/regions`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  .then(res => res.json())


export const saveRegion = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/regions`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editRegion = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/regions/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteRegion = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/regions/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('crmprodtkn'))
    }
  )
  return await res.json()
}